<template>
  <Layout>
    <div class="row">
      <div class="container">
        <div class="row">
          <div class="col-md-6 mx-auto col-sm-12 border">
            <div class="login-form">
              <!-- <router-link tag="a" to="/home" style="font-size: 24px;" class="text-primary float-right">
                <i class="bx bx-home"></i>
              </router-link> -->
              <div class="row justify-content-center">
                <a href="/">
                  <img class="mb-2 mt-4 ml-1" src="@/assets/images/logo_main.svg" alt="" width="180">
                </a>
                <div class="card-body pt-0 text-center" v-if="isLoading">
                  <div class="col-3 mx-auto mt-4">
                    <LottieAnimation ref="anim" :animationData="require('@/assets/json/loading.json')" loop />
                  </div>
                  <h4 class="mt-3">Envoi du message...</h4>
                  <p>Nous transmettons votre message, veuillez patienter</p>
                  <p>-----</p>
                </div>
                <div class="card-body pt-0" v-else-if="!showSuccessMessage">
                  <div class="">
                    <p class="mt-2 card bg-light p-4" style="color:#071260;">
                      Contactez-nous via le
                      formulaire ci-dessous. L'équipe FDSU Docs vous répond du lundi au vendredi de 08h à 17h.
                    </p>
                  </div>
                  <br>
                  <form @submit.prevent="registerAccount()">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="lastname">Prénom</label>
                          <input v-model="lastname" type="text" name="lastname" id="lastname" class="form-control"
                            required>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="firstname">Nom</label>
                          <input v-model="firstname" type="text" name="firstname" id="firstname" class="form-control"
                            required>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="email">Adresse email</label>
                      <input v-model="email" type="email" name="email" id="email" class="form-control" required>
                    </div>

                    <div class="form-group">
                      <label for="phone">Téléphone</label>
                      <input v-model="phone" type="phone" name="phone" id="phone" class="form-control" required>
                    </div>

                    <div class="form-group">
                      <label for="subdomain">
                        Votre message
                        <!-- <i class="bx bxs-info-circle text-primary"></i> -->
                      </label>
                      <div class="input-group">
                        <textarea name="" class="form-control" v-model="message" id="" cols="30" rows="3" required></textarea>
                      </div>
                    </div>
                    <div class="mt-4">
                      <b-button class="col-4" type="submit" variant="primary">
                        Envoyer
                      </b-button>
                    </div>
                  </form>
                </div>
                <div class="card-body pt-0 text-center" v-else>
                  <h4 class="mt-4">Message envoyé</h4><br>
                  <p>Votre message a été envoyé avec succès</p>
                  <a href="/">Retour à la page d'accueil</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/auth";
import countries from '@/assets/json/countries.json';
import LandingApi from "../../../api/LandingApi";
import LottieAnimation from 'lottie-web-vue'


/**
 * Login component
 */
export default {
  page: {
    title: "Register",
  },
  components: { 
    Layout,
    LottieAnimation
  },
  data() {
    return {
      countries,
      name: "",
      firstname: "",
      lastname: "",
      email: "",
      phone: "",
      message: "",
      isLoading: false,
      acceptedTerms: false,
      showSuccessMessage: false,
    };
  },
  methods: {
    registerAccount() {
      const accountData = {
        firstname: this.firstname,
        lastname: this.lastname,
        email: this.email,
        phone: this.phone,
        message: this.message,
      }
      this.isLoading = true;
      LandingApi.contactSales(accountData).then(() => {
        this.showSuccessMessage = true;
        this.isLoading = false;
      }).catch(() => {
        this.$toasted.error("Une erreur est survenue ! veuillez réessayer", {
          duration: 4000,
          position: "top-center",
        });
        this.isLoading = false;
      });
    },
  },
};
</script>

<style scoped>
  .input-group {
    background-color: #f1f5fa !important;
    border-radius: 8px;
  }
  #log_anim{
    margin-top: 10em;
  }
  .sidenav {
    height: 100%;
    background-color: #071260;
    background: linear-gradient(30deg,#071260 50%,#1f397a);
    overflow-x: hidden;
    padding-top: 20px;

  }

  .main {
    height: 100%;
    padding: 0px 10px;
  }

  @media screen and (max-height: 450px) {
    .sidenav {
      padding-top: 15px;
    }
  }

  @media screen and (max-width: 450px) {
    
  }

  @media screen and (min-width: 768px){
    .main{
      margin-left: 44%;
      position: fixed;
      z-index: 1;
      top: 0;
      left: 0;
      background-color: #fff;
      width: 60%;
    }

    .sidenav{
      width: 46%;
      position: fixed;
      z-index: 1;
      top: 0;
      left: 0;
    }

    .login-form{
      padding: 20px;
    }

    .tab-content{
      border: 1px solid;
    }
  }
  .card {
    margin-bottom: 24px;
    /* box-shadow: 0 .75rem 1.5rem rgba(18,38,63,.13); */
  }
</style>
